export const FIRST_PUSH_ONBOARDING_KEY = "iraq-gold-first-push-onboarding-v1";
export const INSTALLED_PUSH_ONBOARDING_KEY = "iraq-gold-installed-push-onboarding-v1";

export function getFirstPushOnboardingStorageKey(isInstalledPwa: boolean) {
  return isInstalledPwa ? INSTALLED_PUSH_ONBOARDING_KEY : FIRST_PUSH_ONBOARDING_KEY;
}

export function shouldShowFirstPushOnboarding({ handled, permission, pushEnabled, hasPublicKey }: { handled: boolean; permission: NotificationPermission | "unsupported"; pushEnabled: boolean; hasPublicKey: boolean }) {
  return !handled && permission === "default" && !pushEnabled && hasPublicKey;
}
